<template>
  <div class="inicio">
    <md-layout md-flex="100" class="m-t-16" md-align="center">
      <md-layout md-flex-xsmall="100" md-flex-small="100" md-flex-medium="100" md-flex-large="70" md-flex-xlarge="50">
        <div class="md-title">
          Punto {{punto.nombre_pun}}
          <br>Horario: {{moment(punto.inicio_ptu,'h:mm:ss').format('h:mm A')}} a {{moment(punto.termino_ptu,'h:mm:ss').format('h:mm A')}}
        </div>
        <div class="md-subheading">{{punto.nombre}}</div>
        <md-layout md-flex="100" md-align="center">
          <md-layout>
            <md-checkbox id="lun1" name="lun1" v-model="rol.lun1">Lun</md-checkbox>
          </md-layout>
          <md-layout>
            <md-checkbox id="mar1" name="mar1" v-model="rol.mar1">Mar</md-checkbox>
          </md-layout>
          <md-layout>
            <md-checkbox id="mie1" name="mie1" v-model="rol.mie1">Mie</md-checkbox>
          </md-layout>
          <md-layout>
            <md-checkbox id="jue1" name="jue1" v-model="rol.jue1">Jue</md-checkbox>
          </md-layout>
          <md-layout>
            <md-checkbox id="vie1" name="vie1" v-model="rol.vie1">Vie</md-checkbox>
          </md-layout>
          <md-layout>
            <md-checkbox id="sab1" name="sab1" v-model="rol.sab1">Sab</md-checkbox>
          </md-layout>
          <md-layout>
            <md-checkbox id="dom1" name="dom1" v-model="rol.dom1">Dom</md-checkbox>
          </md-layout>
          <md-layout md-flex="100">
            <md-button class="md-raised md-accent" @click.native="agregarRol()">Agregar rol</md-button>
          </md-layout>
        </md-layout>
        <md-card class="m-t-24 w-100" v-if="roles.length > 0">
          <md-card-header>
            <div class="md-title">Roles por registrar</div>
            <div class="md-subhead"></div>
          </md-card-header>
          <md-table>
            <md-table-header>
              <md-table-row>
                <md-table-head></md-table-head>
                <md-table-head>L 1</md-table-head>
                <md-table-head>M 1</md-table-head>
                <md-table-head>M 1</md-table-head>
                <md-table-head>J 1</md-table-head>
                <md-table-head>V 1</md-table-head>
                <md-table-head>S 1</md-table-head>
                <md-table-head>D 1</md-table-head>
              </md-table-row>
            </md-table-header>
            <md-table-body>
              <md-table-row v-for="(r, index) in roles" :key="index">
                <md-table-cell>
                  <md-button class="md-icon-button" @click.native="borrarRolPreGuardado(index)">
                    <md-icon>delete</md-icon>
                  </md-button>
                </md-table-cell>
                <md-table-cell>
                  <md-icon v-if="r.lun1">check</md-icon>
                  <md-icon v-else class="md-warn">pause</md-icon>
                </md-table-cell>
                <md-table-cell>
                  <md-icon v-if="r.mar1">check</md-icon>
                  <md-icon v-else class="md-warn">pause</md-icon>
                </md-table-cell>
                <md-table-cell>
                  <md-icon v-if="r.mie1">check</md-icon>
                  <md-icon v-else class="md-warn">pause</md-icon>
                </md-table-cell>
                <md-table-cell>
                  <md-icon v-if="r.jue1">check</md-icon>
                  <md-icon v-else class="md-warn">pause</md-icon>
                </md-table-cell>
                <md-table-cell>
                  <md-icon v-if="r.vie1">check</md-icon>
                  <md-icon v-else class="md-warn">pause</md-icon>
                </md-table-cell>
                <md-table-cell>
                  <md-icon v-if="r.sab1">check</md-icon>
                  <md-icon v-else class="md-warn">pause</md-icon>
                </md-table-cell>
                <md-table-cell>
                  <md-icon v-if="r.dom1">check</md-icon>
                  <md-icon v-else class="md-warn">pause</md-icon>
                </md-table-cell>
              </md-table-row>
            </md-table-body>
          </md-table>
          <md-card-actions>
            <md-button @click.native="abrirModalCancelarRoles()">Cancelar</md-button>
            <md-button @click.native="guardarRolesCapturados()">Guardar Roles</md-button>
          </md-card-actions>
        </md-card>
        <md-card class="m-t-24 w-100">
          <md-card-header>
            <div class="md-title">Roles registrados</div>
            <div class="md-subhead"></div>
          </md-card-header>
          <md-table>
            <md-table-header>
              <md-table-row>
                <md-table-head></md-table-head>
                <md-table-head>Empleado</md-table-head>
                <md-table-head>L 1</md-table-head>
                <md-table-head>M 1</md-table-head>
                <md-table-head>M 1</md-table-head>
                <md-table-head>J 1</md-table-head>
                <md-table-head>V 1</md-table-head>
                <md-table-head>S 1</md-table-head>
                <md-table-head>D 1</md-table-head>
              </md-table-row>
            </md-table-header>
            <md-table-body>
              <md-table-row v-for="(rr, index) in rolesRegistrados" :key="index">
                <md-table-cell>
                  <md-button class="md-icon-button" @click.native="borrarRol(rr,index)">
                    <md-icon>delete</md-icon>
                    <md-tooltip>Eliminar rol</md-tooltip>
                  </md-button>
                  <md-button class="md-icon-button" @click.native="buscarEmpleado(rr,index)" v-if="!rr.id_emn">
                    <md-icon>person_add</md-icon>
                    <md-tooltip>Asignar empleado</md-tooltip>
                  </md-button>
                  <md-button class="md-icon-button" @click.native="buscarEmpleado(rr)" v-else>
                    <md-icon>transfer_within_a_station</md-icon>
                    <md-tooltip>Cambiar empleado</md-tooltip>
                  </md-button>
                  <md-button class="md-icon-button" @click.native="cambiarIntercaladoRol(rr)" v-if="rr.cambio_rol === 'activo'">
                    <md-icon>filter_1</md-icon>
                    <md-tooltip>Rol esta semana</md-tooltip>
                  </md-button>
                  <md-button class="md-icon-button" @click.native="cambiarIntercaladoRol(rr)" v-else>
                    <md-icon>filter_2</md-icon>
                    <md-tooltip>Rol en siguiente semana</md-tooltip>
                  </md-button>
                </md-table-cell>
                <md-table-cell>
                  <span v-if="rr.id_emn">{{rr.nombre}}</span>
                </md-table-cell>
                <md-table-cell>
                  <md-icon v-if="rr.lun1_rol === '1'">check</md-icon>
                  <md-icon v-else class="md-warn">pause</md-icon>
                </md-table-cell>
                <md-table-cell>
                  <md-icon v-if="rr.mar1_rol === '1'">check</md-icon>
                  <md-icon v-else class="md-warn">pause</md-icon>
                </md-table-cell>
                <md-table-cell>
                  <md-icon v-if="rr.mie1_rol === '1'">check</md-icon>
                  <md-icon v-else class="md-warn">pause</md-icon>
                </md-table-cell>
                <md-table-cell>
                  <md-icon v-if="rr.jue1_rol === '1'">check</md-icon>
                  <md-icon v-else class="md-warn">pause</md-icon>
                </md-table-cell>
                <md-table-cell>
                  <md-icon v-if="rr.vie1_rol === '1'">check</md-icon>
                  <md-icon v-else class="md-warn">pause</md-icon>
                </md-table-cell>
                <md-table-cell>
                  <md-icon v-if="rr.sab1_rol === '1'">check</md-icon>
                  <md-icon v-else class="md-warn">pause</md-icon>
                </md-table-cell>
                <md-table-cell>
                  <md-icon v-if="rr.dom1_rol === '1'">check</md-icon>
                  <md-icon v-else class="md-warn">pause</md-icon>
                </md-table-cell>
              </md-table-row>
            </md-table-body>
          </md-table>
        </md-card>
      </md-layout>
    </md-layout>
    <md-dialog md-open-from="#custom" md-close-to="#custom" ref="modalBuscarEmpleado">
      <md-dialog-content>
        <p>Ingrese el nombre del empleado a buscar</p>
        <md-input-container>
          <md-autocomplete :fetch="fetchFunction" print-attribute="nombre" :debounce="1000" :minChars="3" v-model="autocompleteValue" @selected="funcionSelect($event)" />
        </md-input-container>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click.native="cerrarModalBuscarEmpleado()">Cancelar</md-button>
        <md-button class="md-primary md-raised" @click.native="confirmarEmpleado()">Asignar Empleado</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog md-open-from="#custom" md-close-to="#custom" ref="modalCancelarRoles">
      <md-dialog-title>¿Desea borrar los roles capturados?</md-dialog-title>
      <md-dialog-actions>
        <md-button @click.native="cerrarModalCancelarRoles()">Cancelar</md-button>
        <md-button class="md-primary md-raised" @click.native="borrarRolesCapturados()">Si, deseo borrarlos</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import sha1 from "js-sha1";
import md5 from "blueimp-md5";
import Snackbar from "node-snackbar";
import moment from "moment";
export default {
  name: "inicio",
  methods: {
    moment(a, b) {
      return moment(a, b);
    },
    obtenerPunto() {
      this.$http
        .post("turnos", {
          token: this.$session.get("token"),
          turno: this.$route.params.turno
        })
        .then(
          response => {
            if (response.status === 200 && "turno" in response.body) {
              this.punto = response.body.turno;
            }
          },
          response => {
            Snackbar.show({
              text: "No se pudo establecer conexión con el servidor.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    },
    obtenerRolesRegistrados() {
      this.$http
        .post("roles", {
          token: this.$session.get("token"),
          turno: this.$route.params.turno
        })
        .then(
          response => {
            if (response.status === 200 && "roles" in response.body) {
              this.rolesRegistrados = response.body.roles;
            }
          },
          response => {
            Snackbar.show({
              text: "No se pudo establecer conexión con el servidor.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    },
    guardarRolesCapturados() {
      this.$http
        .post("roles/guardar", {
          token: this.$session.get("token"),
          turno: this.punto.id_ptu,
          roles: this.roles
        })
        .then(
          response => {
            if (response.status === 200 && "msg" in response.body) {
              Snackbar.show({
                text: response.body.msg,
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false
              });
              this.roles = [];
              this.rolesRegistrados = null;
              this.obtenerRolesRegistrados();
            } else {
              Snackbar.show({
                text: response.body.error,
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false,
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          },
          response => {
            Snackbar.show({
              text: "No se pudo establecer conexión con el servidor.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    },
    validarCheckDias() {
      if (
        this.rol.lun1 === true ||
        this.rol.mar1 === true ||
        this.rol.mie1 === true ||
        this.rol.jue1 === true ||
        this.rol.vie1 === true ||
        this.rol.sab1 === true ||
        this.rol.dom1 === true
      ) {
        return true;
      } else {
        Snackbar.show({
          text: "Se debe seleccionar por lo menos un día de trabajo.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
        return false;
      }
    },
    agregarRol() {
      if (this.validarCheckDias()) {
        this.roles.push({
          lun1: this.rol.lun1,
          mar1: this.rol.mar1,
          mie1: this.rol.mie1,
          jue1: this.rol.jue1,
          vie1: this.rol.vie1,
          sab1: this.rol.sab1,
          dom1: this.rol.dom1
        });
        this.rol.lun1 = null;
        this.rol.mar1 = null;
        this.rol.mie1 = null;
        this.rol.jue1 = null;
        this.rol.vie1 = null;
        this.rol.sab1 = null;
        this.rol.dom1 = null;
      }
    },
    abrirModalCancelarRoles() {
      this.$refs["modalCancelarRoles"].open();
    },
    cerrarModalCancelarRoles() {
      this.$refs["modalCancelarRoles"].close();
    },
    borrarRolesCapturados() {
      this.roles = [];
      this.cerrarModalCancelarRoles();
    },
    borrarRolPreGuardado(index) {
      this.roles.splice(index, 1);
    },
    borrarRol(rol, index) {
      this.$http
        .post("roles/borrar", {
          token: this.$session.get("token"),
          rol: sha1(md5(rol.id_rol))
        })
        .then(
          response => {
            if (response.status === 200 && "msg" in response.body) {
              Snackbar.show({
                text: response.body.msg,
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false
              });
              this.rolesRegistrados.splice(index, 1);
            } else {
              Snackbar.show({
                text: response.body.error,
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false,
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          },
          response => {
            Snackbar.show({
              text: "No se pudo establecer conexión con el servidor.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    },
    buscarEmpleado(rol, index) {
      this.rolEditado = rol.id_rol;
      this.$refs["modalBuscarEmpleado"].open();
    },
    confirmarEmpleado() {
      if (this.rolEmpleado) {
        this.$http
          .post("roles/asignar", {
            token: this.$session.get("token"),
            rol: sha1(md5(this.rolEditado)),
            empleado: this.rolEmpleado.id_emn
          })
          .then(
            response => {
              if (response.status === 200 && "msg" in response.body) {
                console.log(response.body.msg);
                this.obtenerRolesRegistrados();
                this.autocompleteValue = null;
              }
            },
            response => {
              Snackbar.show({
                text: "No se pudo establecer conexión con el servidor.",
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false,
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          );
      } else {
        Snackbar.show({
          text: "Debe seleccionar un empleado.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      }
      this.obtenerRolesRegistrados();
      this.cerrarModalBuscarEmpleado();
    },
    cerrarModalBuscarEmpleado() {
      this.rolEmpleado = null;
      this.rolEditado = null;
      this.$refs["modalBuscarEmpleado"].close();
    },
    funcionSelect(e) {
      this.rolEmpleado = e;
    },
    fetchFunction(param) {
      return this.$http
        .post("empleados/buscar", {
          token: this.$session.get("token"),
          query: param.q
        })
        .then(
          function(response) {
            return response.body;
          },
          response => {
            console.log("error?");
          }
        );
    },
    cambiarIntercaladoRol(rr) {
      this.$http
        .post("roles/cambiarsemana", {
          token: this.$session.get("token"),
          rol: rr.id_rol,
          estatus: rr.cambio_rol
        })
        .then(
          response => {
            if (response.status === 200 && "msg" in response.body) {
              Snackbar.show({
                text: response.body.msg,
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false
              });
              this.obtenerRolesRegistrados();
            } else {
              Snackbar.show({
                text: response.body.error,
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false,
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          },
          response => {
            Snackbar.show({
              text: "No se pudo establecer conexión con el servidor.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    }
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  created() {
    this.obtenerPunto();
    this.obtenerRolesRegistrados();
  },
  data() {
    return {
      punto: [],
      rol: {
        lun1: null,
        mar1: null,
        mie1: null,
        jue1: null,
        vie1: null,
        sab1: null,
        dom1: null
      },
      roles: [],
      rolesRegistrados: [],
      /*asignación de empleados a roles*/
      rolEmpleado: null,
      rolEditado: null,
      /*fin de asignación de empleados a roles*/
      autocompleteValue: null
    };
  }
};
</script>


// WEBPACK FOOTER //
// PuntosRoles.vue?9f5d20a6